import {addDays} from "date-fns";
import {convertDateStringToUTCDate} from "@/utils/dateUtil";

export function issuableExpired(issuable : any, today : any): boolean {
  return issuable.expirationDate && convertDateStringToUTCDate(issuable.expirationDate!)! < today;
}
export function issuableExpiring(issuable : any, today : any): boolean {
  const dateToCompare = getExpirationNoticeDate(issuable);
  if (!dateToCompare || issuableExpired(issuable, today)) {
    return false;
  }
  return dateToCompare! < today;
}

export function getExpirationNoticeDate(issuable : any) {
  if (!issuable.issuedDate && !issuable.expirationDate) {
    return null;
  }
  return issuable.expirationNoticeDate
    ? convertDateStringToUTCDate(issuable.expirationNoticeDate)!
    : addDays(issuable.expirationDate, -30);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/provider/cards/issuables/IssuableUtil.ts